import React from "react";

function Events({ contract }) {
  return <div>Events</div>;
}

export default Events;
